<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>
      <el-tab-pane label="段位管理" name="eight">
        <div>
          <div class="title_div">
            <span class="title-span">发布日期:</span>
            <el-date-picker
              @change="dwStartChange"
              v-model="dwParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="dwEndChange"
              v-model="dwParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="creatDialogVisible = true"
              >新建段位
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="dwList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="段位logo"
                align="center"
                width="200"
              >
                <template slot-scope="scope">
                  <el-image :src="titleUrl + scope.row.logoPath"></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="段位名称" align="center">
              </el-table-column>
              <el-table-column prop="address" label="获得条件" align="center">
                <template slot-scope="scope"
                  >积分达到{{ scope.row.meetPoint }}分</template
                >
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="发布日期"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.createDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <el-table-column prop="address" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="edutDW(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="dwSizeChange"
              @current-change="dwCurrentChange"
              :current-page="dwResult.current"
              :page-size="dwResult.size"
              layout="total,prev, pager, next, sizes"
              :total="dwResult.total"
               :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
        <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="新建段位"
      :visible.sync="creatDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">段 位 名 称:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="dwCreatParams.name"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span">达 到 积 分:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="dwCreatParams.meetPoint"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        ></el-input>
      </div>
      <div class="dialog-div" style="height: 160px">
        <span class="title-span" style="float: left">段 位 Logo:</span>
        <el-upload
          style="float: left"
          class="avatar-uploader"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="creatHandleAvatarSuccess"
          :before-upload="creatBeforeAvatarUpload"
        >
          <img v-if="creatImageUrl" :src="creatImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="creatDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="creatCommit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑段位"
      :visible.sync="editDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">段 位 名 称:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="dwEditParams.name"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span">达 到 积 分:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="dwEditParams.meetPoint"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        ></el-input>
      </div>
      <div class="dialog-div" style="height: 160px">
        <span class="title-span" style="float: left">段 位 Logo:</span>
        <el-upload
          style="float: left"
          class="avatar-uploader"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="editHandleAvatarSuccess"
          :before-upload="editBeforeAvatarUpload"
        >
          <img v-if="editImageUrl" :src="editImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editCommit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addRankInfo,
  getRankPage,
  updateAntEvent,
  updateRankInfo,
} from "../../api/OperationManagement";
import { globelurl, posturl } from "../../api/axios.js";

export default {
  name: "8RankManagement",
  data() {
    return {
      activeName: "eight",
      upLoadUrl: posturl,
      titleUrl: globelurl,
      headers: { "X-Access-Token": sessionStorage.token },
      dwParams: {
        createDateStart: "",
        createDateEnd: "",
        pageNo: 1,
        pageSize: 10,
      },
      dwCreatParams: {
        name: "",
        meetPoint: "",
        logoPath: "",
      },
      dwEditParams: {
        id: "",
        name: "",
        meetPoint: "",
        logoPath: "",
      },
      dwResult: {},
      dwList: [],
      creatDialogVisible: false,
      editDialogVisible: false,
      editImageUrl: "",
      creatImageUrl: "",
    };
  },
  mounted() {
    this.getRankPage(this.dwParams);
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        // this.$router.push('/OperationManagement/8RankManagement');
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    //段位开始时间改变
    dwStartChange(val) {
      if (
        this.dwParams.createDateStart &&
        this.dwParams.createDateEnd &&
        new Date(this.dwParams.createDateStart).getTime() >
          new Date(this.dwParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.dwParams.pageNo = 1;
      this.getRankPage(this.dwParams);
    },
    //段位结束时间改变
    dwEndChange(val) {
      if (
        this.dwParams.createDateStart &&
        this.dwParams.createDateEnd &&
        new Date(this.dwParams.createDateStart).getTime() >
          new Date(this.dwParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.dwParams.pageNo = 1;
      this.getRankPage(this.dwParams);
    },
    dwSizeChange(newSize) {
      this.dwParams.pageSize = newSize;
      this.getRankPage(this.dwParams);
    },
    dwCurrentChange(newPage) {
      this.dwParams.pageNo = newPage;
      this.getRankPage(this.dwParams);
    },
    //获取段位列表
    getRankPage(params) {
      getRankPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.dwResult = res.data.result;
            this.dwList = res.data.result.records;
          } else {
            this.dwResult = res.data.result;
            this.dwList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑段位
    edutDW(info) {
      this.editDialogVisible = true;
      this.dwEditParams.id = info.id;
      this.dwEditParams.name = info.name;
      this.dwEditParams.meetPoint = info.meetPoint;
      this.dwEditParams.logoPath = info.logoPath;
      this.editImageUrl = globelurl + info.logoPath;
    },
    //新建活动图片上传
    creatHandleAvatarSuccess(res, file) {
      this.dwCreatParams.logoPath = res.result.pathList[0];
      this.creatImageUrl = globelurl + res.result.pathList[0];
    },
    creatBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //编辑活动图片上传
    editHandleAvatarSuccess(res, file) {
      this.dwEditParams.logoPath = res.result.pathList[0];
      this.editImageUrl = globelurl + res.result.pathList[0];
    },
    editBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //新建段位上传
    creatCommit() {
      if (this.dwCreatParams.name == "") {
        this.$message.error("请输入段位名称");
      } else if (this.dwCreatParams.meetPoint === "") {
        this.$message.error("请输入达到积分");
      } else if (this.dwCreatParams.logoPath === "") {
        this.$message.error("请上传段位Logo");
      } else {
        addRankInfo(this.dwCreatParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建段位成功");
              this.creatDialogVisible = false;
              this.getRankPage(this.dwParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //编辑段位上传
    editCommit() {
      if (this.dwEditParams.name == "") {
        this.$message.error("请输入段位名称");
      } else if (this.dwEditParams.meetPoint === "") {
        this.$message.error("请输入达到积分");
      } else if (this.dwEditParams.logoPath === "") {
        this.$message.error("请上传段位Logo");
      } else {
        updateRankInfo(this.dwEditParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("编辑段位成功");
              this.editDialogVisible = false;
              this.getRankPage(this.dwParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.dialog-div {
  margin: 20px 50px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>


<style>
.el-upload {
  border: 1px dashed #d9d9d9;
  margin-left: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

